import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { WebapiService } from 'src/app/ClassFile/webapi.service';

@Component({
  selector: 'app-edit-lab',
  templateUrl: './edit-lab.component.html',
  styleUrls: ['./edit-lab.component.scss']
})
export class EditLabComponent implements OnInit {

  getID = "";
  getLabName = "";
  getContactNumber = "";
  getDescription = "";
  getExperiance = "";
  getCity = "";
  getLat = "";
  getLon = "";
  getLogo = "";
  getLogo_old = "";
  getHours = "";
  getStatus = "Active";

  getFileType = "";
  getCityListArray;

  ImgSelectedFile: File = null;

  constructor(private toastr: ToastrService,private webApiService: WebapiService,private route: ActivatedRoute) {
    this.getID = this.route.snapshot.params.id;
    this.ViewList();
    this.getLabByid();
  }

  ngOnInit(): void {

  }

  getLabByid(){
    console.log("run");

    let userData = {
      id: this.getID,
    }

    this.webApiService.getLabByID(userData).subscribe((res => {
      //console.log(res);

      if(res == ""){
        this.toastr.error("Empty Data", "NO Data Found");
      }else{
        let body = JSON.parse(JSON.stringify(res));
        console.log(body);

        this.getLabName = body.name;
        this.getContactNumber = body.contact;
        this.getDescription = body.description;
        this.getExperiance = body.experience;
        this.getCity = body.city;
        this.getLat = body.lng;
        this.getLon = body.lng;
        this.getLogo_old = body.logo;
        this.getHours = body.openhours;
        // this.getDescription = body.description;
        // this.getPrice = body.unitPrice;
        // this.getAvailability = body.customAvailable;

        //this.getTestingListArray = res;
        //console.log(this.getLabListArray);
      }

  }), (err) => {
      this.toastr.error(err.error.Error, 'Error!');
  })




  }

  Validation(){

      if(this.getLabName == "" || this.getContactNumber == "" || this.getDescription == "" || this.getCity == "" || this.getLat == "" || this.getLon == ""){
        this.toastr.error('Please Fill Empty Fields', 'Error!');
      }else{
        // if(this.getFileType == "image/png" || this.getFileType == "image/jpeg" || this.getFileType == "image/jpg"){
          this.Save();
        // }else{
        //   this.toastr.error('Selected File Not Valid. please select Image.', 'Error!');
        // }
      }
  }

  Save(){
 
    const labData = {
      id: this.getID,
      name: this.getLabName,
      contact: this.getContactNumber,
      description: this.getDescription,
      experience: this.getExperiance,
      openhours: this.getHours,
      city: this.getCity,
      lat: this.getLat,
      lng: this.getLon,
      logo: this.getLogo,
      oldLogo: this.getLogo_old,
      addedBy: 'admin',
      status: this.getStatus
  };

    this.webApiService.editLabData(labData).subscribe((res => {

        console.log(res);
        this.toastr.success(res + "", 'Success!');
        // let response = JSON.stringify(res);
        // let e_data = JSON.parse(response).Data;
        // let e_code = JSON.parse(response).Code;

        // if(e_code == "S100"){
        //   this.toastr.success(e_data, 'Info!');
        //   this.router.navigate(['/Login']);
        // }else if(e_code == "E100"){
        //   this.toastr.error(e_data, "Error!");
        // }else{
        //   this.toastr.error('Something went wrong Please try Again', 'Error!');
        // }

    }), (err) => {
      console.log(err);

        this.toastr.error('Something went wrong Please try Again', 'Error!');
    })





  }

    _handleReaderLoaded(readerEvt) {
      var binaryString = readerEvt.target.result;
      this.getLogo = btoa(binaryString);

    }

    getBase64(event)  {
      this.ImgSelectedFile = event.target.files;
      this.getFileType = this.ImgSelectedFile[0].type;
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(this.ImgSelectedFile[0]);

  }


  ViewList(){


    this.webApiService.getCites().subscribe((res => {

        if(res == ""){
          this.toastr.error("Empty Data", "NO Data Found");
        }else{
          this.getCityListArray = res;
          //console.log(this.getLabListArray);
        }

    }), (err) => {
        this.toastr.error(err.error.Error, 'Error!');
    })



  }


}
